// extracted by mini-css-extract-plugin
module.exports = {"labelContent":"cc_labelContent_1014780759","labelLink":"cc_labelLink_1014780759"};